import React from 'react';

export function makeEmojiIcon(emoji) {
  return function EmojiIcon({ className, ...props }) {
    return (
      <span className={`${className || ''} emoji-icon`} role="img" {...props}>
        {emoji}
      </span>
    );
  };
}

// Game icons
export const BookIcon = makeEmojiIcon('🔤');
export const PairsIcon = makeEmojiIcon('👫');
export const HebrewIcon = makeEmojiIcon('🕎');
export const GreekIcon = makeEmojiIcon('🏛️');
export const NumbersIcon = makeEmojiIcon('🔢');
export const SortIcon = makeEmojiIcon('📚');
export const TestamentIcon = makeEmojiIcon('📜');
export const VerseIcon = makeEmojiIcon('✏️');
export const QuoteIcon = makeEmojiIcon('💬');
export const CrownIcon = makeEmojiIcon('👑');
export const GeographyIcon = makeEmojiIcon('🗺️');
export const LocatorIcon = makeEmojiIcon('📍');
export const ParablesIcon = makeEmojiIcon('🌱');
export const TimelineIcon = makeEmojiIcon('⏳');
export const MiraclesIcon = makeEmojiIcon('✨');
export const ProverbsIcon = makeEmojiIcon('🦉');
export const OccupationsIcon = makeEmojiIcon('🛠️');
export const PromisesIcon = makeEmojiIcon('🌈');
export const ApostlesIcon = makeEmojiIcon('🐟');
export const AnimalsIcon = makeEmojiIcon('🦁');
export const PlantsIcon = makeEmojiIcon('🌿');
export const WatersIcon = makeEmojiIcon('🌊');
export const CitiesIcon = makeEmojiIcon('🏰');
export const FoodsIcon = makeEmojiIcon('🍞');
export const FeastsIcon = makeEmojiIcon('🕯️');
export const CommandmentsIcon = makeEmojiIcon('⚖️');
export const MountainsIcon = makeEmojiIcon('🏔️');
export const DreamsIcon = makeEmojiIcon('🌙');
export const BattlesIcon = makeEmojiIcon('⚔️');
export const CovenantsIcon = makeEmojiIcon('🤝');
export const SongsIcon = makeEmojiIcon('🎵');
export const ClothingIcon = makeEmojiIcon('👘');
export const NationsIcon = makeEmojiIcon('🌍');
export const PrayersIcon = makeEmojiIcon('🙏');
export const FamiliesIcon = makeEmojiIcon('👨‍👩‍👧‍👦');
export const OddOneOutIcon = makeEmojiIcon('👁️');
export const ChainIcon = makeEmojiIcon('🔗');
export const ScenesIcon = makeEmojiIcon('🖼️');
export const PuzzleGameIcon = makeEmojiIcon('🧩');
export const MemoryIcon = makeEmojiIcon('🃏');
export const MatchIcon = makeEmojiIcon('💎');
export const SequenceIcon = makeEmojiIcon('🔠');
export const SwipeIcon = makeEmojiIcon('✅');
export const HangmanIcon = makeEmojiIcon('🎯');

// Header icons
export const DiceIcon = makeEmojiIcon('🏆');
export const ChartIcon = makeEmojiIcon('📊');
export const SearchIcon = makeEmojiIcon('🔍');
export const GearIcon = makeEmojiIcon('⚙️');

// Stats icons
export const StarIcon = makeEmojiIcon('⭐');
export const CheckIcon = makeEmojiIcon('✓');

// Mechanic filter icons
export const QuizFilterIcon = makeEmojiIcon('❓');
export const TreeIcon = makeEmojiIcon('🌳');
export const FlagIcon = makeEmojiIcon('🚩');

// Team mode icons
export const UsersIcon = makeEmojiIcon('👥');
export const XIcon = makeEmojiIcon('✕');
export const PlusIcon = makeEmojiIcon('+');
export const MinusIcon = makeEmojiIcon('−');
export const RotateIcon = makeEmojiIcon('🔄');
export const TrophyIcon = makeEmojiIcon('🏆');
export const TeamCrownIcon = makeEmojiIcon('👑');
